<template>
    <k-panel>
        <k-panel-header>{{ $t("accountActivation") }}</k-panel-header>
        <div v-if="verificationSteps.length !== 0">
            <k-panel-row :key="step.step" v-for="step in verificationSteps">
                <div slot="left">
                    <div class="ml-2">
                        <div class="font-semibold text-sm">{{step.title}}</div>
                        <div>
                            <span class="text-xs text-gray-700">{{step.description}}</span>
                        </div>
                    </div>
                </div>
                <div slot="right">
                    <a-button slot="actions" type="primary" class="mr-2"
                              @click="handleActivationStep(step)">
                        {{step.action}}
                    </a-button>
                </div>
            </k-panel-row>
        </div>
        <k-panel-row v-if="verificationSteps.length === 0">
            <div slot="left">{{ $t("identityVerificationInProgress") }}</div>
        </k-panel-row>
    </k-panel>
</template>

<script>

    export default {
        props: {
            verificationSteps: {
                type: Array,
                required: true
            },
        },
        data() {
            return {};
        },
        methods: {
            async handleActivationStep(step) {
                this.$emit('handle-step', step)
            }
        }
    };
</script>


